export const authRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue'),
    },
    {
        path: '/invalid',
        name: 'InvalidToken',
        redirect: { name: 'Login' },
    },
    {
        path: '/setPassword',
        name: 'SetPassword',
        component: () => import('../views/SetPassword.vue'),
    },
    {
        path: '/forgotPassword',
        name: 'ForgotPassword',
        component: () => import('../views/ForgotPassword.vue'),
    },
];
